import { observer } from 'mobx-react-lite';
import React from 'react';

import LogCard from '@/entities/log/ui/LogCard/LogCard';
import { WeeklyWorkLog } from '@/types';

import s from './AttendeeLogCheckerPanel.module.scss';

type LogListProps = {
  logs: WeeklyWorkLog[];
  emptyMessage: string;
};

const LogList: React.FC<LogListProps> = ({ logs, emptyMessage }) => {
  if (logs.length === 0) {
    return <p className={s.empty}>{emptyMessage}</p>;
  }

  return (
    <div className={s.log_list}>
      {logs.map((log) => (
        <div key={log.id} className={s.log_list__item}>
          <LogCard log={log} onOpenDetails={() => {}} readOnly />
        </div>
      ))}
    </div>
  );
};

export default observer(LogList);
